var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEA0B6"
    },
    d: "M256,377.89l-148.91,27.02C127.952,467.151,186.736,512,256,512s128.048-44.849,148.91-107.09 L256,377.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71CCCE"
    },
    d: "M107.09,107.09C44.849,127.952,0,186.736,0,256s44.849,128.048,107.09,148.91L134.11,256 L107.09,107.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA4820"
    },
    d: "M404.91,107.09L377.89,256l27.02,148.91C467.151,384.048,512,325.264,512,256 S467.151,127.952,404.91,107.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7AD3F"
    },
    d: "M256,0c-69.264,0-128.048,44.849-148.91,107.09L256,134.11l148.91-27.021 C384.048,44.849,325.264,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20AAB0"
    },
    d: "M157.021,98.979c-17.456,0-34.244,2.853-49.931,8.11c-5.257,15.686-8.11,32.474-8.11,49.931 c0,37.525,13.17,71.969,35.131,98.979l121.89-49.931V134.11C228.99,112.151,194.545,98.979,157.021,98.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F76720"
    },
    d: "M404.91,107.09c-15.685-5.257-32.474-8.11-49.931-8.11c-37.525,0-71.969,13.17-98.979,35.131v71.959 L377.89,256c21.961-27.01,35.131-61.455,35.131-98.979C413.021,139.564,410.167,122.775,404.91,107.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA4820"
    },
    d: "M256,134.11c-22.846,18.575-40.371,43.438-49.931,71.959h99.861 C296.372,177.549,278.846,152.685,256,134.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA5B82"
    },
    d: "M256,305.931L134.11,256c-21.961,27.01-35.131,61.455-35.131,98.979 c0,17.456,2.853,34.244,8.11,49.931c15.686,5.257,32.474,8.11,49.931,8.11c37.525,0,71.969-13.17,98.979-35.131v-71.958H256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D92622"
    },
    d: "M377.89,256L256,305.931v71.959c27.01,21.961,61.455,35.131,98.979,35.131 c17.456,0,34.244-2.853,49.931-8.11c5.257-15.686,8.111-32.474,8.111-49.931C413.021,317.455,399.85,283.01,377.89,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD0A3A"
    },
    d: "M206.069,305.931c9.559,28.521,27.084,53.384,49.931,71.959 c22.846-18.575,40.372-43.438,49.931-71.959H206.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,197.959c-49.195,0-93.098,22.63-121.89,58.041c28.79,35.411,72.694,58.041,121.89,58.041 c49.195,0,93.099-22.63,121.89-58.041C349.099,220.589,305.195,197.959,256,197.959z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#41BBBE"
    },
    cx: 256,
    cy: 256,
    r: 58.041
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#06484A"
    },
    d: "M256,272.879c-9.307,0-16.879-7.572-16.879-16.879c0-9.307,7.572-16.879,16.879-16.879 c9.307,0,16.879,7.572,16.879,16.879C272.879,265.307,265.307,272.879,256,272.879z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.db6ddf0b79904255931632a19e968434.svg";
export { ForwardRef as ReactComponent };